(() => {
    let refreshing = false;
    
    const refreshDrawer = () => {
      if (refreshing) return;
      refreshing = true;
      
      fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
        .then(r => r.json())
        .then(data => {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && drawer.querySelector('#CartDrawer')) {
            drawer.querySelector('#CartDrawer').innerHTML = 
              new DOMParser()
                .parseFromString(data['cart-drawer'], 'text/html')
                .querySelector('#CartDrawer').innerHTML;
          }
          setTimeout(() => { refreshing = false; }, 500);
        })
        .catch(() => { refreshing = false; });
    };
    
    const waitForDrawer = () => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) {
        setTimeout(waitForDrawer, 100);
        return;
      }
      
      let wasActive = false;
      
      new MutationObserver(() => {
        const isActive = cartDrawer.classList.contains('active');
        if (isActive && !wasActive) {
          setTimeout(refreshDrawer, 1500);
          setTimeout(refreshDrawer, 4000);
        }
        wasActive = isActive;
      }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });

      cartDrawer.addEventListener('click', (e) => {
        const btn = e.target.closest('button.quantity__button');
        if (!btn) return;
        setTimeout(refreshDrawer, 1000);
        setTimeout(refreshDrawer, 2000);
      });
    };
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitForDrawer);
    } else {
      waitForDrawer();
    }
  })(); 